import createVueApp from '@phoenix/createVueApp';
import GiftFinder from '@maison/components/giftFinder/GiftFinder.vue';

const app = createVueApp({}, true);
app.component('GiftFinder', GiftFinder);
app.mount('#phoenix-gift-finder');
